import React from "react";
import { Col, Row } from "react-bootstrap";

function ResearchInterests() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
       <Col xs={4} md={2} className="tech-icons">
        <h4>Geographical Information Systems (GIS)</h4>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
      <h4>Computer Vision</h4>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
      <h4>Machine Learning</h4>
      </Col>
      {/* <Col xs={4} md={2} className="tech-icons">
      <h4>Embedded Systems</h4>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
      <h4>Human Computer Interaction</h4>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
      <h4>Distributed Systems</h4>
      </Col> */}
    </Row>
  );
}

export default ResearchInterests;
